import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';

export const authGuard: CanActivateChildFn = (childRoute, state) => {
  const router = inject(Router);

  const sessionToken = localStorage.getItem('sessionToken');
  if (sessionToken) {
    return true;
  }
  return router.createUrlTree(['login']);
};
